import React, { useState } from 'react'
import classes from "./style.module.scss";

const ProductDetails = ({referenceNumber, type, quantity}) => {

    return (
        <>
            <div className={`${classes.enquiryCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Product Details
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Product Name</div>
                            <div className={`${classes.infoValue}`}>{referenceNumber}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Product Type</div>
                            <div className={`${classes.infoValue}`}>{type}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Quantity</div>
                            <div className={`${classes.infoValue}`}>{quantity}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductDetails